export default __webpack_public_path__ + "static/media/password.114dce43.svg";